import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-33a4ca9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginContainer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_3 = { class: "formContainer p-5 position-relative" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { class: "fw_600" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { class: "text-center mt-3 mb-4" }
const _hoisted_13 = { class: "text-muted mb-1" }
const _hoisted_14 = { class: "fw_600" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger fs_14 mt-2"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "mt-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "Validating invitation...",
              text: "Validating invitation..."
            })
          ]))
        : (!_ctx.tokenValid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_localized_text, {
                type: "h3",
                localizedKey: "Invalid Invitation",
                text: "Invalid Invitation",
                class: "mb-3"
              }),
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "This invitation link is invalid or has expired.",
                  text: "This invitation link is invalid or has expired."
                })
              ]),
              _createVNode(_component_router_link, {
                to: "/login",
                class: "btn btn-secondary mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Go to Login",
                    text: "Go to Login"
                  })
                ]),
                _: 1
              })
            ]))
          : (_ctx.alreadyRegistered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_localized_text, {
                  type: "h3",
                  localizedKey: "Account Exists",
                  text: "Account Exists",
                  class: "mb-3"
                }),
                _createElementVNode("p", _hoisted_8, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "You already have an account. Please login to accept the invitation.",
                    text: "You already have an account. Please login to accept the invitation."
                  })
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.tokenInfo.email), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.tokenInfo.providerName) + " · " + _toDisplayString(_ctx.tokenInfo.supplierCode), 1),
                _createElementVNode("p", _hoisted_10, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Invited by",
                    text: "Invited by"
                  }),
                  _createTextVNode(": " + _toDisplayString(_ctx.tokenInfo.companyName), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: { path: '/provider-login', query: { token: _ctx.model.token } },
                  class: "btn btn-tertiary mt-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Go to Login",
                      text: "Go to Login"
                    })
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  type: "h2",
                  localizedKey: "Provider Registration",
                  text: "Provider Registration",
                  class: "text-center"
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "You have been invited by",
                      text: "You have been invited by",
                      class: "me-1"
                    }),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.tokenInfo.companyName), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.tokenInfo.email), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.tokenInfo.providerName) + " · " + _toDisplayString(_ctx.tokenInfo.supplierCode), 1)
                ]),
                _createElementVNode("form", {
                  class: "mt-4",
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
                }, [
                  _createVNode(_component_form_field, {
                    type: "password",
                    modelValue: _ctx.model.password,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.password) = $event)),
                    placeholderKey: "Password",
                    placeholderValue: "Password",
                    labelKey: "Password *",
                    labelValue: "Password *",
                    required: true
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_form_field, {
                    type: "password",
                    modelValue: _ctx.model.confirmPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.confirmPassword) = $event)),
                    placeholderKey: "Confirm Password",
                    placeholderValue: "Confirm Password",
                    labelKey: "Confirm Password *",
                    labelValue: "Confirm Password *",
                    required: true
                  }, null, 8, ["modelValue"]),
                  (_ctx.passwordMismatch)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Passwords do not match",
                          text: "Passwords do not match"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary text-center justify-content-center w-100 mt-4",
                    disabled: _ctx.registerDisabled
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Register",
                      text: "Register"
                    })
                  ], 8, _hoisted_16)
                ], 32),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_localized_text, {
                    class: "grey d-block mb-1",
                    localizedKey: "Already have an account?",
                    text: "Already have an account?"
                  }),
                  _createVNode(_component_router_link, {
                    to: { path: '/provider-login', query: { token: _ctx.model.token } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Login",
                        text: "Login"
                      })
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
    ])
  ]))
}